export default function checkStateFilingValue(state1: any, state2: any) {
  if (state1 === state2) {
    return false;
  } else {
    return true;
  }
}
